import request from "@utils/request"

/**
 * 首页
 * @returns {*}
 */
export function getHomeData () {
  return request.get("index", {}, { login: false })
}

/**
 * 文章 轮播列表
 * @returns {*}
 */
export function getArticleBanner () {
  return request.get("/article/banner/list", {}, { login: false })
}

/**
 * 文章分类列表
 * @returns {*}
 */
export function getArticleCategory () {
  return request.get("/article/category/list", {}, { login: false })
}

/**
 * 文章 热门列表
 * @returns {*}
 */
export function getArticleHotList () {
  return request.get("/article/hot/list", {}, { login: false })
}

/**
 * 文章列表
 * @returns {*}
 */
export function getArticleList (q, cid) {
  return request.get("/article/list/" + cid, q, { login: false })
}

/**
 * 分享
 * @returns {*}
 */
export function getShare () {
  return request.get("/share", {}, { login: false })
}

/**
 * 文章详情
 * @returns {*}
 */
export function getArticleDetails (id) {
  return request.get("/article/details/" + id, {}, { login: false })
}

/**
 * 获取微信sdk配置
 * @returns {*}
 */
export function getWechatConfig () {
  return request.get(
    "/wechat/config",
    { url: document.location.href },
    { login: false }
  )
}

/**
 * 获取微信sdk配置
 * @returns {*}
 */
export function wechatAuth (code, spread, login_type) {
  return request.get(
    "/wechat/auth",
    { code, spread, login_type },
    { login: false }
  )
}
/**
 * 获取快递公司
 * @returns {*}
 */
export function getLogistics () {
  return request.get("/logistics", {}, { login: false })
}

/**
 * 获取登陆logo
 * @returns {*}
 */
export function getLogo (type) {
  return request.get("/wechat/get_logo", { type: type }, { login: false })
}

/**
 * 获取图片base64
 * @retins {*}
 * */
export function imageBase64 (image, code) {
  return request.post(
    "/image_base64",
    { image: image, code: code },
    { login: false }
  )
}

/**
 * 获取关注海报
 * @returns {*}
 */
export function follow () {
  return request.get("/wechat/follow", {}, { login: false })
}

/**
 * 获取城市列表
 * @returns {*}
 */
export function getCity () {
  return request.get("/city_list", {}, { login: false })
}

// 2022.02.25

/**
 * 团队列表接口
 * @param {Object} data
 */
export function getTeamList () {
  return request.get("get/user/team/list", {}, { login: false })
}
/**
 * 首页-二级行业&品牌列表
 * @param {Object} data
 */

export function getBrandLst (data) {
  return request.get(
    "/original/brand/lst?keyword=" + data,
    {},
    { login: false }
  )
}
/**
 * 行业列表
 * @param {Object} data
 */

export function getArticleCateLstNew () {
  return request.get("/article/cate/lst", {}, { login: false })
}
/**
 * 行业获取文章列表
 * @param {Object} data
 */
export function getArticleListNew (data) {
  return request.get("original/lst/" + data, {}, { login: false })
}
/**
 * 品牌获取文章列表
 * @param {Object} data
 */
export function getBrandListNew (data) {
  return request.get("original/brand/list/" + data, {}, { login: false })
}
/**
 * 我的关注 行业/品牌
 * @param {Object} data
 */
export function getFollowLstNew () {
  return request.get("/follow/lst", {}, { login: false })
}
/**
 * 新建品牌、行业
 * @param {Object} data
 */
export function getBrandSaveNew (data) {
  return request.post("/brand/save", data, { login: false })
}
/**
 * 移除我的关注
 * @param {Object} data
 */
export function getFollowCancelNew (data) {
  return request.get("/follow/cancel/" + data, {}, { login: false })
}
/**
 * 获取文章详情
 * @param {Object} data
 */
export function getArticleDetailsNew (data) {
  return request.get(
    "/original/article/details?link_id=" + data,
    {},
    { login: false }
  )
}
/**
 * 添加新增行业
 * @param {Object} data
 */
export function getFollowFollowNew (data) {
  return request.get("/follow/follow/" + data, {}, { login: false })
}
/**
 * 获取团队成员列表
 * @param {Object} data
 */
export function getMembersList (data) {
  return request.get("/get/members/list", data, {}, { login: false })
}
/**
 * 退出团队
 * @param {Object} data
 */
export function postOutTeam (data) {
  return request.post("/out/team", data, {}, { login: false })
}
/**
 * 邀请成员
 * @param {Object} data
 */
export function postShare (data) {
  return request.post("/share/user/article", data, {}, { login: false })
}
/**
 * 设置管理员
 * @param {Object} data
 */
export function postUpStaff (data) {
  return request.post("/set/up/staff", data, {}, { login: false })
}
/**
 * 删除成员
 * @param {Object} data
 */
export function postDelTeamUser (data) {
  return request.post("/del/team/user", data, {}, { login: false })
}
/**
 * 文章/人脉个人中心
 * @param {Object} data
 */
export function getUserInfo (data) {
  return request.get("/article/userInfo" + data, {}, { login: false })
}
/**
 * 个性签名接口
 * @param {Object} data
 */
export function postPersonality (data) {
  return request.post("/personality/sig", data, {}, { login: false })
}
/**
 * 客户联系 加电话/微信接口
 * @param {Object} data
 */
export function postUserContact (data) {
  return request.post("/user/contact", data, { login: false })
}
/**
 * 图片上传
 * @param {Object} data
 */
export function getUploadImageNew (data) {
  return request.post("/upload/image", data, { login: false })
}
/**
 * 图片上传
 * @param {Object} data
 */
export function getArticleAdNew (data) {
  return request.post("/article/ad", data, { login: false })
}
/**
 * 文章收藏及点赞
 * @param {Object} data
 */
export function getArticleCollectAddNew (data) {
  return request.post("/article/collect/add", data, { login: false })
}
/**
 * 文章取消收藏及点赞
 * @param {Object} data
 */
export function getArticleCollectDelNew (data) {
  return request.post("/article/collect/del", data, { login: false })
}
/**
 * 文章广告模板列表
 * @param {Object} data
 */
export function getAdListNew () {
  return request.get("/get/ad/list", {}, { login: false })
}
/**
 * 删除文章广告模板
 * @param {Object} data
 */
export function getDelAdNew (data) {
  return request.post("/del/ad", data, { login: false })
}
/**
 * 个性签名
 * @param {Object} data
 */
export function getPersonalitySigNew (data) {
  return request.post("/personality/sig", data, { login: false })
}
/**
 * 客户线索首页统计
 * @param {Object} data
 */
export function getNumberViewsTodayNew (data) {
  return request.get("/number/views/today", data, { login: false })
}

/**
 * 客户线索列表
 * @param {Object} data
 */
export function getClientListNew (data) {
  return request.get("/client/list" + data, {}, { login: false })
}
/**
 * 视频列表
 * @param {Object} data
 */
export function getVideoListNew (data) {
  return request.get("/get/video/list" + data, {}, { login: false })
}
/**
 * 视频详情
 * @param {Object} data
 */
export function getVideoDetailsNew (data) {
  return request.get("/video/details" + data, {}, { login: false })
}
/**
 * 添加及更新视频广告
 * @param {Object} data
 */
export function getVideoAdNew (data) {
  return request.post("/video/ad", data, { login: false })
}
/**
 * 视频收藏及点赞
 * @param {Object} data
 */
export function getVideoCollectAddNew (data) {
  return request.post("/video/collect/add", data, { login: false })
}
/**
 * 视频取消收藏及点赞
 * @param {Object} data
 */
export function getVideoCollectDelNew (data) {
  return request.post("/video/collect/del", data, { login: false })
}
/**
 * 视频广告模板列表
 * @param {Object} data
 */
export function getAdVideoListNew (data) {
  return request.get("/get/ad/video/list", data, { login: false })
}
/**
 * 删除视频广告模板
 * @param {Object} data
 */
export function getDelVideoAdNew (data) {
  return request.post("/del/video/ad", data, { login: false })
}
/**
 * 添加项目
 * @param {Object} data
 */
export function getAddProjectNew (data) {
  return request.post("/add/project", data, { login: false })
}
/**
 * 获取项目详情
 * @param {Object} data
 */
export function getProjectDetailsNew (data) {
  return request.get("/project/details" + data, {}, { login: false })
}
/**
 * 获取项目列表
 * @param {Object} data
 */
export function getProjectListNew () {
  return request.get("/project/list", {}, { login: false })
}
/**
 * 删除项目
 * @param {Object} data
 */
export function getDelProjectNew (data) {
  return request.post("/del/project", data, { login: false })
}
/**
 * 提交面诊信息
 * @param {Object} data
 */
export function getAddConsultation (data) {
  return request.post("/add/consultation", data, { login: false })
}
/**
 * 面诊信息列表
 * @param {Object} data
 */
export function getUserConsultationList (data) {
  return request.get("/user/consultation/list" + data, {}, { login: false })
}
/**
 * 设置默认广告
 * @param {Object} data
 */
export function getAddAdDefault (data) {
  return request.post("/add/ad/default", data, { login: false })
}
/**
 * 取消默认广告
 * @param {Object} data
 */
export function getDelAdDefault (data) {
  return request.post("/del/ad/default", data, { login: false })
}
/**
 * 文章自主修改
 * @param {Object} data
 */
export function postArticleEdit (data) {
  return request.post("/article/edit", data, { login: false })
}
/**
 * 获取子分类-首页-老王说医美
 * @param {Object} data
 */
export function getChildCategoryList (data) {
  return request.get("/get/child/category/list" + data)
}
/**
 * 获取首页老王说医美-子分类对应的列表
 * @param {Object} data
 */
export function getIndexArticle (data) {
  return request.get("/get/index/article" + data)
}
/**
 * 文章分享回调
 * @param {Object} data
 */
export function postShareArticle (data) {
  return request.post("/share/article", data, { login: true })
}
/**
 * 首页banner
 * @param {Object} data
 */
export function getIndex (data) {
  return request.get("/index", data)
}

/**
 * 首页弹窗
 * @param {Object} data
 */
export function getShareActivity (data) {
  return request.get("/share/activity", data)
}
